import { z } from 'zod';

/**
 * Schéma pour la création/édition d'un établissement
 */
export const establishmentSchema = z.object({
  name: z.string().min(3, 'Le nom doit contenir au moins 3 caractères'),
  shortName: z.string().optional().nullable(),
  uai: z
    .string()
    .regex(
      /^[0-9]{7}[A-Z]$/,
      'Le code UAI doit être au format 7 chiffres + 1 lettre majuscule'
    ),
  typeId: z.string().uuid("Le type d'établissement est requis"),
  category: z.string().min(1, 'La catégorie est requise'),
  status: z.string().optional(),
  streams: z.array(z.string()).optional(),
  email: z.string().email('Email invalide').optional().nullable(),
  phone: z
    .string()
    .regex(
      /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
      'Numéro de téléphone invalide'
    )
    .optional()
    .nullable(),
  website: z
    .string()
    .url('URL invalide')
    .optional()
    .nullable()
    .or(z.literal('')),
  street: z
    .string()
    .min(5, "L'adresse doit contenir au moins 5 caractères")
    .optional()
    .nullable(),
  addressComplement: z.string().optional().nullable(),
  city: z
    .string()
    .min(2, 'La ville doit contenir au moins 2 caractères')
    .optional()
    .nullable(),
  postalCode: z
    .string()
    .regex(/^[0-9]{5}$/, 'Le code postal doit contenir 5 chiffres')
    .optional()
    .nullable(),
  department: z
    .string()
    .min(2, 'Le département est requis')
    .optional()
    .nullable(),
  region: z.string().min(2, 'La région est requise'),
  academy: z.string().min(2, "L'académie est requise"),
});

export type EstablishmentFormData = z.infer<typeof establishmentSchema>;
